import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container mx-auto">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6">
            <div>
              <img className="w-75 mb-2" src="images/logo.png" alt="logo" />
              <p class="mb-30">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus
                voluptas eum illo. Accusantium nesciunt nihil nisi velit modi,
                vitae laboriosam!
              </p>
            </div>
          </div>
          <div class="col-xl-2 offset-xl-1 col-lg-2 col-md-6">
            <div class="">
              <h3>Quick Link</h3>
              <ul class="list-unstyled">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/">About Us</a>
                </li>
                <li>
                  <a href="/">Why The Code pIlot</a>
                </li>
                <li>
                  <a href="/">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div>
              <h3>Services</h3>
              <ul class="list-unstyled">
                <li>
                  <a href="/">Lorem ipsum dolor?</a>
                </li>
                <li>
                  <a href="/">Lorem ipsum dolor?</a>
                </li>
                <li>
                  <a href="/">Lorem ipsum dolor?</a>
                </li>
                <li>
                  <a href="/">Lorem ipsum dolor?</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div>
              <h3>Contact</h3>
              <p>C 140,New York, USA</p>
              <p>+99 232 23223 222</p>
              <p>
                <span className="me-2"> Email:</span>
                <a href="/">thecodepilot@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-5">
          <div class="copyright">
            <p>
              Copyright © {new Date().getFullYear()}{" "}
              <span className="copy">The Code Pilot</span> Right Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
